module.exports = {"modalTitle":"Kies een of meerdere regio's","title":"Abonnementen","intro":"Voor welke regio('s) wil je de abonnementen zien?","selectRegions":"Kies jouw regio('s)","changeRegionSelection":"Wijzig jouw regio('s)","buttonText":"Bekijk abonnementen"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/nl/region-select.json
// module id = ROR9
// module chunks = 1